import { useContext } from 'react';
import { useTypedFlags } from '@axo/shared/services/feature-flags';
import { useHasAnyOfRoles } from '@axo/shared/data-access/provider';
import { permissions } from '@axo/shared/data-access/types';
import { ACEFlags } from '../../utils/ACEFlags';
import { ApplicationContext } from '../../store/context';

export function useShouldUseBuckets() {
  const { state } = useContext(ApplicationContext);

  const { flag_bucket_assignment_system } = useTypedFlags(ACEFlags);

  const marketSupportsBuckets = flag_bucket_assignment_system?.includes(
    state.marketCountry,
  );

  const roleSupportsBucket = useHasAnyOfRoles([
    permissions.RoleName.Manager,
    permissions.RoleName.Sales,
  ]);

  return marketSupportsBuckets && roleSupportsBucket;
}
